import Splide from '@splidejs/splide';

const EL = '.js-card-gallery';

document.querySelectorAll('.js-card-gallery').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'fade',
    arrows: true,
    pagination: true,
    breakpoints: {
      1024: {

      },
      767: {

      },
    },
  });

  slider.mount();
});
